// Dependencies
import { FC } from 'react';
import { Typography } from '@mui/material';

// Export access page
export const NotAllowedContent: FC = () => {
  // Return access page
  return (
    <Typography variant="h3" align="center">
      You're not allowed to this page!
    </Typography>
  );
};
